var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_142_4552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_142_4552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7423 6.81571C17.5549 6.75395 17.43 6.75395 17.305 6.75395C17.3675 6.75395 17.2426 6.75395 17.305 6.75395H12.6822V3.29545C12.6822 2.49259 12.0575 1.875 11.2454 1.875H9.37123C9.12135 1.875 8.9964 1.93676 8.80899 1.99852C8.55911 2.06028 8.37169 2.24555 8.18428 2.43083L4.93579 6.56868H2.68683C1.87471 6.63044 1.25 7.24802 1.25 8.05089V16.0795C1.25 16.8824 1.87471 17.5 2.68683 17.5H14.7437C15.0561 17.5 15.3684 17.3765 15.6183 17.1912C15.8682 17.0059 15.9932 16.7589 16.0556 16.5119L18.6794 8.60672C18.9293 7.80385 18.492 7.00099 17.7423 6.81571ZM3.81131 14.7208V9.40958H4.93579V14.7208H3.81131ZM7.55957 14.7208V7.92737L9.871 4.96295V8.17441C9.871 8.97727 10.4957 9.59486 11.3078 9.59486H15.3684L13.6817 14.7208H7.55957V14.7208Z",
    fill: "#65AA20"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassTest);
export default __webpack_public_path__ + "static/media/pass_test.11aeb34c77f9fedaea2f20148083cdd2.svg";
export { ForwardRef as ReactComponent };